import { Controller } from "@hotwired/stimulus"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ["background", "content"]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    if (window.innerWidth < 1024) return

    this.setupParallax()
  }

  setupParallax() {
    gsap.set(this.backgroundTarget, { scale: 1.3 })

    this.bgTrigger = gsap.to(this.backgroundTarget, {
      yPercent: -18,
      ease: "none",
      scrollTrigger: {
        trigger: this.element,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.5
      }
    })

    this.contentTrigger = gsap.to(this.contentTarget, {
      yPercent: -12,
      ease: "none",
      scrollTrigger: {
        trigger: this.element,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.3
      }
    })
  }

  disconnect() {
    ScrollTrigger.getAll().forEach(t => {
      if (t.trigger === this.element) t.kill()
    })
  }
}
